<div *ngIf="quiz" class="quiz">
  <p *ngFor="let line of quiz.instruction" class="quiz-instruction">
    <ng-container *ngTemplateOutlet="rich; context: { $implicit: line }"></ng-container>
  </p>

  <!-- single_select / multi_select -->
  <ng-container *ngIf="isSelect">
    <p class="quiz-prompt">
      <ng-container *ngTemplateOutlet="rich; context: { $implicit: quiz.prompt }"></ng-container>
    </p>
    <label *ngFor="let option of quiz.options" class="quiz-option" [ngClass]="optionClass(option)">
      <input [type]="multiple ? 'checkbox' : 'radio'" [name]="quiz.id" [checked]="chosen.includes(option.id)"
             [disabled]="checked" (change)="toggle(option)">
      <span><ng-container *ngTemplateOutlet="rich; context: { $implicit: option.segments }"></ng-container></span>
    </label>
  </ng-container>

  <!-- gap_fill / wordpool / blank_fill: the prompt with inline controls in place of the gaps -->
  <ng-container *ngIf="quiz.type === 'gap_fill' || quiz.type === 'wordpool' || quiz.type === 'blank_fill'">
    <p class="quiz-prompt quiz-prompt-gaps">
      <ng-container *ngFor="let segment of quiz.prompt" [ngSwitch]="segment.kind">
        <ng-container *ngSwitchCase="'text'">
          <ng-container *ngTemplateOutlet="rich; context: { $implicit: [segment] }"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'gap'">
          <input *ngIf="quiz.type === 'blank_fill'" type="text" class="form-control form-control-sm quiz-blank"
                 [ngClass]="slotClass(segment.value)" [(ngModel)]="values[segment.value]" [disabled]="checked"
                 autocomplete="off">
          <!-- the choices are the select's own options (no separate list of answers above the sentence) -->
          <select *ngIf="quiz.type !== 'blank_fill'" class="form-select quiz-gap"
                  [ngClass]="slotClass(segment.value)" [(ngModel)]="values[segment.value]" [disabled]="checked">
            <option value=""></option>
            <option *ngFor="let option of quiz.options" [value]="option.id">{{ option.text }}</option>
          </select>
        </ng-container>
      </ng-container>
    </p>
  </ng-container>

  <!-- matching: one card per numbered statement, the advice is picked from the select -->
  <ng-container *ngIf="quiz.type === 'matching'">
    <div *ngFor="let item of quiz.items" class="quiz-match" [ngClass]="slotClass(item.n)">
      <span class="quiz-match-n">{{ item.n }}</span>
      <div class="quiz-match-body">
        <div class="quiz-match-text"><ng-container *ngTemplateOutlet="rich; context: { $implicit: item.segments }"></ng-container></div>
        <select class="form-select form-select-sm" [(ngModel)]="values[item.n]" [disabled]="checked">
          <option value=""></option>
          <option *ngFor="let option of quiz.options" [value]="option.id">{{ option.id }}) {{ option.text }}</option>
        </select>
        <div *ngIf="checked && slotClass(item.n) === 'is-wrong'" class="quiz-match-answer">
          {{ 'EBOOKS.QUIZ.CORRECT_ANSWER' | translate }}: {{ correctAnswerLabel(item.n) }}
        </div>
      </div>
    </div>
  </ng-container>

  <div class="quiz-actions">
    <span *ngIf="checked" class="quiz-result" [class.quiz-result-correct]="allCorrect" [class.quiz-result-wrong]="!allCorrect">
      {{ (allCorrect ? 'EBOOKS.QUIZ.CORRECT' : 'EBOOKS.QUIZ.INCORRECT') | translate }}
    </span>
    <button *ngIf="!checked" type="button" class="btn btn-primary btn-sm rounded-pill" [disabled]="!canCheck" (click)="verify()">
      {{ 'EBOOKS.QUIZ.CHECK' | translate }}
    </button>
    <button *ngIf="!checked" type="button" class="btn btn-outline-secondary btn-sm rounded-pill" (click)="showAnswers()">
      {{ 'EBOOKS.QUIZ.SHOW_ANSWERS' | translate }}
    </button>
    <button *ngIf="checked" type="button" class="btn btn-outline-primary btn-sm rounded-pill" (click)="reset()">
      {{ 'EBOOKS.QUIZ.TRY_AGAIN' | translate }}
    </button>
    <button *ngIf="checked && allCorrect" type="button" class="btn btn-primary btn-sm rounded-pill" (click)="done.emit()">
      {{ 'EBOOKS.QUIZ.OK' | translate }}
    </button>
  </div>
</div>

<!-- Rich text of an exercise: text with its <b>/<i>/<u> formatting. -->
<ng-template #rich let-segments>
  <ng-container *ngFor="let segment of segments">
    <span *ngIf="segment.kind === 'text'" [class.fw-bold]="segment.bold" [class.fst-italic]="segment.italic" [class.text-decoration-underline]="segment.underline">{{ segment.value }}</span>
  </ng-container>
</ng-template>
